module.exports = "https://static.wmbcdn.com/uniweb/images/9a5c2b0e6c274b7680e51db29e50cc56.svg";